export default "<div class=\"preloader\">\n  <img src=\"assets/img/preloader.gif\" alt=\"Cargando...\">\n</div>";